import { AddDistrictAdminRequestRequest, RemoveDistrictAdminRequestRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateDistrictAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: AddDistrictAdminRequestRequest }) =>
      SSF.api.districtsAddDistrictAdminCreate(id, payload),
    onSuccess: (_, { id }) => client.invalidateQueries({ queryKey: keys.list(id) }),
  });
}

export function useRemoveDistrictAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RemoveDistrictAdminRequestRequest }) =>
      SSF.api.districtsRemoveDistrictAdminCreate(id, payload),
    onSuccess: (_, { id }) => client.invalidateQueries({ queryKey: keys.list(id) }),
  });
}
